import * as React from "react";
import { useTranslation } from "react-i18next";

//MUI Icons
import CheckCircleIcon from "@mui/icons-material/CheckCircle";

//Custom components
import CardToolbarMenuItem from "@/ui/Card/CardToolbarMenuItem";

//Types
import { ICardToolbarMenuItemDetail } from "@/@types/ui/Card";

const CardToolbarMenuItemActivate = React.forwardRef<HTMLLIElement, ICardToolbarMenuItemDetail>((props, ref) => {
  const { t } = useTranslation();
  const { onClick } = props;

  return <CardToolbarMenuItem label={t("buttons.activate")} icon={<CheckCircleIcon />} onClick={onClick} ref={ref} />;
});

export default CardToolbarMenuItemActivate;
